import React, { useState, useEffect } from "react";
import { EventsType } from "../Common/Types/types";
import Spinner from "../Common/Components/spinner";
import ErrorMessage from "../Common/Components/ErrorMessage";
import EventsGrid from "./Grid";
import DownloadReportDialog from "./DownloadReportDialog";

interface EventsGridWidgetProps {
  id: string;
  header: string;
  term: string;
  filteredEvents: EventsType[];
  loading: boolean;
  error: string;
}

const EventsGridWidget = (props: EventsGridWidgetProps) => {
  const [eventsData, updateEventsData] = useState<EventsType[]>(null);

  const [dialogVisible, updateDialogVisible] = useState(false);
  const [ids, updateIds] = useState(null);

  useEffect(() => {
    updateEventsData(props.filteredEvents);
  }, [props.filteredEvents]);

  const updateIdsHandler = (_ids: any) => {
    updateIds(_ids);
    toggleDialog();
  };
  const toggleDialog = () => {
    dialogVisible ? updateDialogVisible(false) : updateDialogVisible(true);
  };
  if (props.loading) {
    return <Spinner text="data" />;
  } else if (eventsData != null && eventsData.length == 0) {
    return (
      <ErrorMessage
        text={"No data found for selected filters."}
        id={props.id}
        header={props.header}
      />
    );
  } else if (props.error) {
    return (
      <ErrorMessage text={props.error} id={props.id} header={props.header} />
    );
  } else if (eventsData != null && eventsData.length > 0) {
    return (
      <>
        <EventsGrid data={eventsData} updateIdsHandler={updateIdsHandler} />
        <DownloadReportDialog
          visible={dialogVisible}
          toggleVisible={toggleDialog}
          ids={ids}
        />
      </>
    );
  }
};
export default EventsGridWidget;
